// Process titles are composed on the server from ProcessType.TitleTemplate, whose text ends
// with "بعنوان {title}". Each process fills {title} with the request id — see
// InquiryProcess.GenerateTitle and its siblings in Momra.EForms.BLL/Processes/Initiation.
// The composed string is frozen into ProcessInstance.Title when the process is created, so
// the suffix cannot be removed from stored rows without a data migration; it is dropped here,
// on display only.
const PROCESS_TITLE_SUFFIX = /\s*بعنوان\s+.*$/

const stripProcessTitleSuffix = function (value) {
	if (!value) return ''
	return String(value).replace(PROCESS_TITLE_SUFFIX, '').trim()
}

export { stripProcessTitleSuffix }
